import React, {useMemo} from 'react'
import {
    Box,
    Image,
    useMediaQuery
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useGlobalSettingsContentful} from '../../clients/contentful/hooks/use-global-settings-contentful.hook'

const ItemImageDefault = () => {
    const [isDesktop] = useMediaQuery('(min-width: 992px)')
    const globalSettingsData = useGlobalSettingsContentful()

    const image = useMemo(() => {
        const {mobile = null, desktop = null} =
            globalSettingsData?.globalSettingsCollection?.items?.[0]
                ?.defaultProductMedia ?? {}
        if (mobile && !isDesktop) return mobile
        return desktop
    }, [globalSettingsData])

    return (
        <>
            {image && (
                <Image
                    alt={image?.title || 'Image'}
                    src={`${image?.url}`}
                    fallback={<Box background="gray.100" boxSize="full" />}
                />
            )}
        </>
    )
}

export default ItemImageDefault
